module.exports = __webpack_public_path__ + "static/media/logo.7423f0f3.png";